import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Spin } from 'antd';

import { getAssignmentTemplateDetails } from 'redux/reducers/assignmentSlice';
import { useAppDispatch } from 'hooks/useAppDispatch';
import BaseAlert from 'components/wrappers/BaseAlert';
import { ApiErrorMessage } from 'constants/ErrorMessages';
import { AssignmentTemplateDetailsResponse } from 'api/backofficeApiClient';
import AssignmentsPrimaryInfoSection from '../AssignmentDetailsPage/AssignmentPrimaryInfoSection';
import { AssignmentMode } from '../AssignmentDetailsPage/AssignmentPrimaryInfoSection/AssignmentsPrimaryInfoSection';

type ParamsProps = {
  templateId: string;
};

export default function AssignmentTemplateDetailsPage() {
  const { templateId = '' } = useParams<ParamsProps>();
  const [isInitialLoaded, setIsInitialLoaded] = useState(false);
  const [assignmentTemplateDetails, setAssignmentTemplateDetails] =
    useState<AssignmentTemplateDetailsResponse>();

  const dispatch = useAppDispatch();

  const loadAssignmentTemplateDetails = useCallback(async () => {
    const result = await dispatch(getAssignmentTemplateDetails(templateId));

    if (getAssignmentTemplateDetails.fulfilled.match(result)) {
      setAssignmentTemplateDetails(result.payload);
    } else {
      BaseAlert.error(result.error.message || ApiErrorMessage);
    }
    setIsInitialLoaded(true)
  }, [dispatch, templateId]);

  useEffect(() => {
    loadAssignmentTemplateDetails();
    // eslint-disable-next-line
  }, []);

  if (!isInitialLoaded) return <Spin size="large" />;

  return (
    <div className="page-wrapper scroll-box">
      <div className="page-holder">
        {assignmentTemplateDetails && (
          <AssignmentsPrimaryInfoSection
            mode={AssignmentMode.Template}
            assignmentDetails={assignmentTemplateDetails}
            loadAssignmentDetails={loadAssignmentTemplateDetails}
          />
        )}
      </div>
    </div>
  );
}
